
import React from "react";
import { CheckCircle } from "lucide-react";
import Educationcycle from "./Educationcycle";
import Footer from "../../Home/Footer";
import Faqs from "../../Home/Faqs";
const travelLeadData = {
  heading: "Boost Your Education Goals with WhatsApp | ChatMitra",
  points: [
    "Speed up admissions with instant WhatsApp messaging.",
    "Engage students with automated, personal chats.",
    "Simplify communication with powerful analytics.",
  ],
  buttons: [
    { text: "Get Start ", className: "bg-[#075E54] text-white hover:bg-[#076M54]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_1.png",
};

const educationFAQs = [
  {
    question: "How can WhatsApp improve educational outcomes?",
    answer: "WhatsApp can enhance learning by sending course updates, study tips, and reminders directly to students. It’s like having a personal tutor keeping everyone on track, 24/7!"
  },
  {
    question: "Is WhatsApp secure for sharing school materials?",
    answer: "Yes, WhatsApp’s encryption ensures syllabi, assignments, and grades stay safe. It’s like locking your educational resources in a vault, so students and parents can trust you."
  },
  {
    question: "Can WhatsApp handle school admissions?",
    answer: "Absolutely! Guide applicants through enrollment, answer questions, and send welcome kits via WhatsApp. It’s like rolling out the red carpet for new students effortlessly."
  },
  {
    question: "How does WhatsApp support teachers and students?",
    answer: "Offer real-time help for homework, tech issues, or exam prep via WhatsApp. It’s like having a support team that’s always ready to assist, boosting engagement."
  },
  {
    question: "What educational content should I share on WhatsApp?",
    answer: "Share lesson plans, motivational quotes, and event invites via WhatsApp. It’s a direct line to keep students inspired and parents informed, no matter where they are."
  },
  {
    question: "Can WhatsApp schedule school events?",
    answer: "Yes! Students and parents can book parent-teacher meetings or workshops via WhatsApp, with reminders to ensure no one misses out. It’s a flexible way to stay organized."
  },
  {
    question: "How do students feel about using WhatsApp for education?",
    answer: "They love it! Students appreciate the convenience, speed, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making learning feel modern."
  },
  {
    question: "Can WhatsApp reduce administrative tasks in education?",
    answer: "Definitely! Automate responses to queries and manage schedules via WhatsApp, freeing up staff for teaching. It’s like having an extra assistant in the office!"
  },
  {
    question: "How can I gather feedback on WhatsApp for schools?",
    answer: "Send surveys or ask for reviews on courses and services via WhatsApp. It’s a quick way to improve and show you value student and parent input."
  },
  {
    question: "How do I integrate WhatsApp into my educational institution?",
    answer: "Set up WhatsApp Business, create chat templates for support and updates, and use tools like ChatMitra. It’s a simple step to boost your educational goals!"
  },
];

const Education = () => {
  return (
    <>
      <section className="flex flex-col md:flex-col lg:flex-row gap-8 md:gap-12 bg-white max-w-6xl mx-auto mt-32 mb-10 px-6 sm:px-0 ">
        <div className="w-full md:w-full lg:w-1/2 text-left md:pl-8 mb-8 md:mb-0">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
            {travelLeadData.heading}
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            Discover how WhatsApp for education transforms student engagement and streamlines processes with ChatMitra.
          </p>
          <ul className="mt-6 sm:mt-8 space-y-4 sm:space-y-6 text-lg">
            {travelLeadData.points.map((point, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="text-[#075E54] w-4 h-4 mr-2 self-center flex-shrink-0" strokeWidth={3} />
                {point}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-4 justify-left md:justify-start">
            {travelLeadData.buttons.map((button, index) => (
              <a
              key={index}
              href={button.buttonLink}
              className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
            >
              {button.text}
            </a>
            ))}
          </div>
        </div>
        <div className="w-full md:w-full lg:w-1/2 flex justify-center">
          <img
            src={travelLeadData.image}
            alt="WhatsApp for Education Chatbot Flow"
            className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
          />
        </div>
      </section>
      <Educationcycle />
      <Faqs faqs={educationFAQs} />
      <title>Boost Your Education Goals with WhatsApp | ChatMitra</title>
      <meta name="description" content="Elevate your education institution with WhatsApp for education. Speed up admissions, engage students with automation, and optimize communication with ChatMitra’s analytics." />
      <meta name="keywords" content="WhatsApp for education, education automation, student engagement, WhatsApp chatbot, admissions, ChatMitra" />
      <link rel="canonical" href="https://blog.chatmitra.com/whatsapp-for-education" />
      <meta property="og:title" content="Boost Your Education Goals with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Learn how WhatsApp for education enhances admissions, student engagement, and communication efficiency with ChatMitra." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-for-education" />
      <meta property="og:type" content="website" />
      <Footer />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "WhatsApp for Education",
            "provider": {
              "@type": "Organization",
              "name": "ChatMitra"
            },
            "description": "Streamline admissions, boost student engagement, and optimize communication for educational institutions using WhatsApp automation."
          }
        `}
      </script>
    </>
  );
};

export default Education;